import React, { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { RootStateOrAny, useSelector } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";
import BrandPerformanceTrendTile from "../BrandPerformanceTrendTile";
import BrandPerformanceTableTile from "../BrandPerformanceTableTile";
import { isNull, isNullOrUndefined } from "../../../../utils/utilityFunctions";
import Ratings from "../../../../components/Ratings/Ratings";

import { getNIMTable, getNIMTrend } from "../../../../api/brandPerformanceApi";

interface Props extends RouteComponentProps {
  onHandleRadioClick: any;
  nissanCompetitor: string;
  diff: number;
  granularity: string;
}

const NIMContent = withRouter((props: Props) => {
  const { diff, nissanCompetitor, onHandleRadioClick, history, granularity } = props;
  const params = useSelector((state: RootStateOrAny) => state.parameters);

  // fetch the trend and average data
  const {
    data: chartData,
    isFetching: loadingTrend, // call data using react-query
    refetch: refetchNIMTrend,
  } = useQuery(["brandVolumeTrend", granularity, history.location.search], () => getNIMTrend({ ...params, nissan_competitor: nissanCompetitor }), {
    enabled: false,
  });

  const {
    data: tableData,
    isFetching: loadingTable,
    refetch: refetchNIMAverage,
  } = useQuery(["brandVolumeAverage", granularity, history.location.search], () => getNIMTable({ ...params, nissan_competitor: nissanCompetitor }), {
    enabled: false,
  });

  // when the url changes, refetch the data
  useEffect(() => {
    refetchNIMTrend();
    refetchNIMAverage();
  }, [history.location.search]);

  const columns = [
    {
      id: "model",
      Header: `Model`,
      accessor: "model",
      defaultCanSort: true,
      sortDescFirst: true,
      sortType: "alphanumericIgnoreCase",
      Cell: (props: { value: string }) => {
        const { value } = props;

        return value;
      },
    },
    {
      Header: "NIM",
      accessor: `score`,
      id: "score",
      defaultCanSort: true,
      defaultSortDesc: true,
      sortDescFirst: true,
      sortType: "alphanumericCustom",
      Cell: ({ value }: { value: number }) => {
        return isNullOrUndefined(value) ? "n/a" : `${value?.toLocaleString()}%`;
      },
    },
    {
      Header: "YOY",
      accessor: `score_yoy`,
      id: "score_yoy",
      defaultCanSort: true,
      defaultSortDesc: true,
      sortDescFirst: true,
      sortType: "alphanumericCustom",
      Cell: ({ value }: { value: number }) => {
        return (
          <div className="cell-data">
            {isNullOrUndefined(value) ? "" : <Ratings value={value} isPercentageValue={false} testValue={false} />}
            {isNullOrUndefined(value) ? "n/a" : `${Math.abs(value)}%`}
          </div>
        );
      },
    },
  ];

  return (
    <div className="brand-market-main-content">
      <BrandPerformanceTrendTile
        title="NIM Trend"
        chartId="nimTrendChart"
        chartData={chartData}
        loadingTrend={loadingTrend}
        diff={diff}
        nissanCompetitor={nissanCompetitor}
        onHandleRadioClick={onHandleRadioClick}
        isPercentage={true}
        chartGranularity={granularity}
      />
      <BrandPerformanceTableTile
        title="NIM average"
        tableId="nimTable"
        tableData={tableData}
        columns={columns}
        loadingTable={loadingTable}
        initialSortCol={{ id: "model", desc: true }}
      />
    </div>
  );
});

export default NIMContent;
